import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "../components/layout/Layout";
import ProductCard from "../components/ProductCard";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { ChevronRight, Filter } from "lucide-react";

export default function Categories() {
  useSeo({
    title: "Kategoriler — Otel Pro",
    description: "500+ otel ekipmanı, uzman kürate edilmiş 6+ kategoride.",
  });
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState([]);
  const [params] = useSearchParams();
  const q = params.get("q") || "";

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data || []));
    api.get("/products", { params: { search: q || undefined, limit: 48 } })
      .then((r) => setProducts(r.data.items || []));
  }, [q]);

  return (
    <Layout>
      {/* Breadcrumb */}
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">Kategoriler</span>
        </div>
      </div>

      {/* Hero */}
      <section className="bg-navy text-white py-16" data-testid="categories-hero">
        <div className="container-site">
          <p className="accent-script text-gold text-xl mb-1">Katalog</p>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold leading-tight">
            Otel Ekipmanları Kategorileri
          </h1>
          <p className="text-white/70 max-w-2xl mt-3">
            Her kategori, uzman ekibimiz tarafından yıldız standartlarına ve konuk deneyimine göre seçildi.
          </p>
          {q && <p className="mt-3 text-gold text-sm">"{q}" için sonuçlar</p>}
        </div>
      </section>

      {/* Category grid */}
      <section className="section-pad">
        <div className="container-site">
          <h2 className="heading-serif text-2xl font-semibold text-navy mb-6">Tüm Kategoriler</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {cats.map((c) => (
              <Link
                key={c.id}
                to={`/kategori/${c.slug}`}
                className="card-premium p-5 text-center group"
                data-testid={`cat-${c.slug}`}
              >
                {c.image && (
                  <div className="aspect-square rounded-md overflow-hidden mb-3">
                    <img src={c.image} alt={c.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="heading-serif text-sm font-semibold text-navy group-hover:text-gold transition-colors">
                  {c.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* All products */}
      <section className="section-pad bg-softbg !pt-0">
        <div className="container-site">
          <div className="flex items-end justify-between mb-6">
            <h2 className="heading-serif text-2xl font-semibold text-navy">
              {q ? `Arama: "${q}"` : "Tüm Ürünler"}
            </h2>
            <span className="text-sm text-gray-500">{products.length} ürün</span>
          </div>
          {products.length === 0 ? (
            <p className="text-center text-gray-500 py-12">Sonuç bulunamadı.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {products.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
